module.exports = __webpack_public_path__ + "img/tenisu.dcddec7b.svg";